<div class="flex flex-row h-full w-full">
  <app-stepper (selectedIndexChange)="changeStep($event)" [(selectedIndex)]="selectedStep" [linear]="linear"
               [nextStepAllowed]="nextStepAllowed"
               [previousStepAllowed]="previousStepAllowed" class="flex flex-row h-full w-full">
      @if (isCheckView) {
        <cdk-step [label]="'Prüfregelauswahl'">
        </cdk-step>
        <cdk-step [label]="'Dateiauswahl'">
        </cdk-step>
        <cdk-step [label]="'Prüfergebnisse'">
        </cdk-step>
      } @else {
        <cdk-step [completed]="true" [label]="'Geprüfte Dateien'">
        </cdk-step>
        <cdk-step [completed]="true" [label]="'Prüfergebnisse'">
        </cdk-step>
      }
    </app-stepper>

</div>
